import { useEffect, useState } from "react";
import * as actions from "../../../../Redux/Actions/index";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, InputGroup, Spinner, Button } from "react-bootstrap";
import { BsCheckLg, BsXLg, BsGear } from "react-icons/bs";
import ClientManagerModal from "../../../../component/ModalComponent/ClientManagerModal";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../../component/Toasts/Toasts";
import { Strings, workDetailsValidation } from "../../../../constant/Strings";
import {
  projectLocationValidation,
  projectProjectNameValidation,
  whiteSpaceValid,
  containsInvalidChars
} from "../../../../constant/Validations";
import Select from "react-select";

const EditWorkDetails = (props: any) => {
  const userLogin: any = localStorage.getItem("login");
  const loginId = JSON.parse(userLogin)?.id;
  const role = localStorage.getItem("role");
  const {
    clientName,
    clientRef,
    workLocation,
    reportingManagerName,
    handleEditWorkDetails,
    eId,
    hrbpName,
    hrbpRef,
    status,
    apiCallCompleted,
    currentLocation,
  } = props;
  const {
    editSuccess,
    work_location,
    cliName,
    reporting_manager_name,
    hrbp_name,
    cancel,
    submit,
    invalidCharsError
  } = Strings;
  const [btnDisable, setBtnDisable] = useState(false);
  const { clientNameValid, workLocationValid } = workDetailsValidation;
  const [employeeData, setEmployeeData] = useState({
    clientName: clientName,
    clientRef: clientRef || "",
    workLocation: workLocation,
    currentLocation: currentLocation,
    reportingManagerName: reportingManagerName,
    hrbpRef: hrbpRef,
    eId: eId,
    updatedBy: eId,
  });
  const [justReassigned, setJustReassigned] = useState(false);
  const [clientOptions, setClientOptions] = useState<any[]>([]);
  const [isAddingClient, setIsAddingClient] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [isSubmittingClient, setIsSubmittingClient] = useState(false);
  const [showClientManager, setShowClientManager] = useState(false);
  const [hrbpInfo, setHrbpInfo] = useState([]);
  const [errors, setErrors] = useState({
    clientName: "",
    workLocation: "",
    currentLocation: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getEmployeeDbHrbpListAction());
    dispatch(actions.getClientNameAction()); // Load Clients
  }, [dispatch]);
  const clientDataRedux = useSelector((state: any) => state.employeeReducer.getClientNameDetails);
  useEffect(() => {
    if (clientDataRedux?.data) setClientOptions(clientDataRedux.data);
  }, [clientDataRedux]);

  // Sync Logic: Auto-clear if deleted
   useEffect(() => {
    if (employeeData.clientName && clientOptions.length > 0) {
      
      const exists = clientOptions.some(c => c.clientName === employeeData.clientName);
      
      
      if (exists) {
         if (justReassigned) setJustReassigned(false);
      } else {
         if (!justReassigned) {
            setEmployeeData(prev => ({ ...prev, clientName: "", clientRef: "" }));
         } else {
            console.log("🛡️ BLOCKED: Name NOT found, but Shield is ON. Keeping field.");
         }
      }
    }
  }, [clientOptions, employeeData.clientName, justReassigned]);

  const handleAddNewClient = () => {
    if (!newClientName.trim() || containsInvalidChars(newClientName)) return;
    setIsSubmittingClient(true);
    dispatch(actions.addClientNameAction({ clientName: newClientName }, (res: any) => {
      setIsSubmittingClient(false);
      if (res?.data || res?.code === 200) {
        const addedName = res?.data?.clientName || newClientName;
        const addedId = res?.data?._id || "";

        // Update Options & Select
        setClientOptions(prev => [...prev, res.data || { clientName: newClientName }]);
        setEmployeeData(prev => ({
          ...prev,
          clientName: addedName,
          clientRef: addedId
        }));

        setIsAddingClient(false);
        setNewClientName("");
        dispatch(actions.getClientNameAction()); // Refresh global list
      } else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add client";
        showErrorToastMessage(errorMsg);
      }
    }) as any);
  };

  const isHrAdmin = (localStorage.getItem("role") || "").includes("hr-admin");

  let valid: boolean = true;
  const validate = () => {
  valid = true; // Reset validity check at the start
  if (employeeData.clientName) {
    if (containsInvalidChars(employeeData.clientName)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        clientName: invalidCharsError,
      }));
    } else if (projectProjectNameValidation(employeeData.clientName) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        clientName: clientNameValid,
      }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, clientName: "" }));
    }
  }

  if (employeeData.workLocation) {
    if (containsInvalidChars(employeeData.workLocation)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        workLocation: invalidCharsError,
      }));
    } else if (
      projectLocationValidation(employeeData.workLocation) == false ||
      whiteSpaceValid(employeeData.workLocation) == false
    ) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        workLocation: workLocationValid,
      }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, workLocation: "" }));
    }
  }

  // Add new validation for Current Location
  if (employeeData.currentLocation) {
    if (containsInvalidChars(employeeData.currentLocation)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        currentLocation: invalidCharsError,
      }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, currentLocation: "" }));
    }
  }
};
  const handleEdit = () => {
    validate();
    if (valid) {
      handleDispatch();
    }
  };
  const handleDispatch = () => {
    apiCallCompleted(false);
    dispatch(
      actions.editEmployeeDataAction(employeeData, (res: any) => {
        if (res?.error?.error_description) {
              showErrorToastMessage(res.error.error_description);
              apiCallCompleted(true);
            }else if(res.code === 200) {
              showSuccessToastMessage(editSuccess);
              apiCallCompleted(true);
            }
      })
    );
    handleEditWorkDetails();
  };
  useEffect(() => {
    dispatch(actions.getEmployeeDbHrbpListAction());
  }, []);

  const employeeHrbpData = useSelector(
    (state: any) => state.employeeReducer.getEmployeeDbHrbpList
  );
  useEffect(() => {
    if (employeeHrbpData && employeeHrbpData.data) {
      setHrbpInfo(employeeHrbpData.data);
    }
  }, [employeeHrbpData, hrbpInfo]);

  useEffect(() => {
    if (employeeData.hrbpRef) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [employeeData]);

  const hrbpOptions: any = hrbpInfo.map((ele: any) => ({
    value: ele._id,
    label: ele.middleName
      ? ele.candidateName +
        " " +
        ele.middleName +
        " " +
        ele.lastname +
        "-" +
        ele.employeeId
      : ele.candidateName + " " + ele.lastname + "-" + ele.employeeId,
  }));
  const handleHrbpManager = (selected: any) => {
    setEmployeeData({
      ...employeeData,
      hrbpRef: selected.value,
    });
  };
  const disableCondition: any =
    (!(role && role.includes("hr")) && status == "Active") ||
    status == "Inactive" ||
    (role && role.includes("hr") && status == "Active" && eId == loginId) || role == "undefined"

  return (
    <div>
      <div className="row g-4">
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {cliName}
          </label>

          {isAddingClient ? (
            <InputGroup>
              <input
                type="text"
                className="form-control"
                placeholder="Enter new client name"
                value={newClientName}
                onChange={(e) => setNewClientName(e.target.value)}
                autoFocus
              />
              <Button variant="primary" onClick={handleAddNewClient} disabled={isSubmittingClient}>
                {isSubmittingClient ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
              </Button>
              <Button variant="outline-secondary" onClick={() => setIsAddingClient(false)}>
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <Dropdown onSelect={(key: any) => {
              if (key === "__ADD__") setIsAddingClient(true);
              else if (key === "__MANAGE__") setShowClientManager(true);
              else {
                const selectedObj = clientOptions.find(c => c.clientName === key);
                setEmployeeData({
                  ...employeeData,
                  clientName: key,
                  clientRef: selectedObj ? selectedObj._id : ""
                });
              }
            }}>
              <Dropdown.Toggle variant="light" className="form-control text-start d-flex justify-content-between align-items-center">
                {employeeData.clientName || "Select..."}
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {/* {isHrAdmin && (
                  <>
                    <Dropdown.Item eventKey="__ADD__" className="text-primary fw-bold">+ Add New Client</Dropdown.Item>
                    <Dropdown.Item eventKey="__MANAGE__" className="text-secondary"><BsGear /> Manage Clients</Dropdown.Item>
                    <Dropdown.Divider />
                  </>
                )} */}
                {clientOptions.map((opt: any) => (
                  <Dropdown.Item key={opt._id} eventKey={opt.clientName}>{opt.clientName}</Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}
          <p className="error">{errors.clientName}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {work_location}
          </label>
          <input
            type="text"
            className="form-control"
            value={employeeData.workLocation}
            onChange={(e) => {
              setEmployeeData({
                ...employeeData,
                workLocation: e.target.value,
              });
            }}
          />
          <p className="error">{errors.workLocation}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Current Location
          </label>
          <input
            type="text"
            className="form-control"
            value={employeeData.currentLocation}
            onChange={(e) => {
              setEmployeeData({
                ...employeeData,
                currentLocation: e.target.value,
              });
            }}
          />
          <p className="error">{errors.currentLocation}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {reporting_manager_name}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={employeeData.reportingManagerName}
            onChange={(e) => {
              setEmployeeData({
                ...employeeData,
                reportingManagerName: e.target.value,
              });
            }}
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{hrbp_name}</label>
          <span className="required">*</span>
          <Select
            className="dropdown-select"
            placeholder={hrbpName}
            options={hrbpOptions}
            isSearchable={true}
            onChange={handleHrbpManager}
            isDisabled={disableCondition}
          />
        </div>
      </div>

      <div className="modal-btn-wrapper mt-4 mb-4">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={handleEditWorkDetails}
          >
            {cancel}
          </button>
        </div>
        <div>
          <button
            className={
              btnDisable
                ? "btn add-submit-button buttonsize"
                : "btn add-submit-button btn-disabled buttonsize"
            }
            onClick={handleEdit}
          >
            {submit}
          </button>
        </div>
      </div>
      <ClientManagerModal
        show={showClientManager}
        onHide={() => setShowClientManager(false)}
        data={clientOptions}
        refreshData={() => dispatch(actions.getClientNameAction())}
        onReassignSuccess={(oldId: string, newTarget: any) => {
            console.log("⚡ EVENT: onReassignSuccess Triggered", newTarget);
            
            // 1. Activate Shield
            setJustReassigned(true);
            const deletedClient = clientOptions.find(c => c._id === oldId);
            const deletedName = deletedClient ? deletedClient.clientName : "";

            //console.log(`Checking match: Ref[${employeeData.clientRef}] vs Id[${oldId}] OR Name[${employeeData.clientName}] vs DeletedName[${deletedName}]`);

            // 2. Robust Check: Match by ID -OR- Match by Name
            if (
                employeeData.clientRef === oldId || 
                (deletedName && employeeData.clientName === deletedName)
            ) {
                
                setEmployeeData(prev => ({
                    ...prev,
                    clientName: newTarget.label, 
                    clientRef: newTarget.value   
                }));
            } else {
                console.log("❌ NO MATCH. Skipping update.");
            }
            setClientOptions([]); 
        }}
      />
    </div>
  );
};

export default EditWorkDetails;
